import { OddsStore } from './store'
export { OddsStore }
export const odds = new OddsStore()
